import clsx from "clsx";

export const Pill = ({
  className = "",
  text = "",
  variation,
  style,
}: {
  className?: string;
  text: string;
  variation: "grey" | "purple" | "green" | "red";
  style?: React.CSSProperties;
}) => {
  return (
    <p
      className={clsx(
        `flex h-fit w-fit min-w-max items-center justify-center rounded-full !py-[2px] px-[6px] text-center text-sm font-bold uppercase ${className}`,
        {
          "bg-grey-50 text-grey-600": variation === "grey",
          "bg-light-purple text-purple": variation === "purple",
          "bg-light-green text-success": variation === "green",
          "bg-light-red text-danger": variation === "red",
        },
      )}
      style={style}
    >
      {text}
    </p>
  );
};
